<template>
	<div>
		<div class="flex gap-2">
			<ProductAvailabilityIndicator :availability="availability" class="m-[0.29rem] sm:m-2" />
			<div>
				<p>
					<span class="typo-body-m mb-1 block">{{ availability.description }}</span>
					<span class="inline-block typo-body-caption text-body-quaternary leading-tight">
						Uvedený stav je pouze orientační. Dostupnost na prodejně se může lišit.
					</span>
				</p>
				<button
					v-if="selectedHypermarketWithFallbackInstance && !hideButton"
					type="button"
					class="typo-body-caption text-body-link underline underline-offset-1 hover:no-underline mt-1 text-left"
					aria-label="Ověřte si skladovost na ostatních pobočkách"
					@click="toggleSlideout()"
				>
					Ověřte si skladovost na ostatních pobočkách
				</button>
			</div>
		</div>
		<AvailabilitySlideout v-model:open="isSlideoutOpen" :vanr="product.vanr!" />
	</div>
</template>

<script setup lang="ts">
	import {storeToRefs} from 'pinia';
	import type {Gsoa_ProductCatalog_ProductDetail as ProductDetail} from '~/openapi';
	import {ProductAvailability} from '~/utils/productAvailability';
	import {useStoryblokHypermarketsStore} from '~/stores/storyblokHypermarkets';
	import AvailabilitySlideout from '~/components/product/AvailabilitySlideout.vue';

	type Props = {
		product: ProductDetail;
		hideButton?: boolean;
	};

	const props = defineProps<Props>();

	const hypermarketsStore = useStoryblokHypermarketsStore();
	const {selectedHypermarketWithFallbackInstance} = storeToRefs(hypermarketsStore);

	const [isSlideoutOpen, toggleSlideout] = useToggle(false);
	const availability = computed(() => ProductAvailability.getAvailability(props.product));
</script>
